module.exports = __webpack_public_path__ + "components/outside-promo-page/static/close-f32d5a2583d14b9677326ee2d5ec16a0.svg";